import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const SET_WINDOW_SIZE = 'la/ui/windowSize/SET';

// reducer
export const DEFAULT_STATE = {
    height: 1024,
    initialWidth: 1024,
    isMobile: false,
    width: 1024,
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case SET_WINDOW_SIZE:
            return {
                ...state,
                height: action.payload.height,
                isMobile: action.payload.width < 768,
                width: action.payload.width,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.windowSize;

export const getWindowSize: (state: GlobalState) => any = createSelector(stateSelector, (state) => state);
export const getInitialWidth: (state: GlobalState) => any = createSelector(
    stateSelector,
    (state): number => state.initialWidth
);

/* ACTION CREATORS */
type SetWindowSizeParams = {
    height: number;
    width: number;
};

export const setWindowSize = ({ height, width }: SetWindowSizeParams) => ({
    payload: { height, width },
    type: SET_WINDOW_SIZE,
});
